__webpack_require__.p = "https://static.justtake.shop/bp/currentVersion/";